import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {CLIENT_JOURNEY_STATE_IS_LOADING} from '/enum/clientJourneyState.enum';
import {THIRD_TAB, WEEKLY_CHECK_INS} from '/enum/clientJourneyTasks.enum';
import {
  fetchClientJourneyTask,
  setClientJourneyState,
  setClientJourneyTasks,
} from '/redux/action/client.action';
import {
  clientJourneyTasksByType,
  currentWeeklyCheckInDate,
  filteredClientJourneyTasks,
  hasWeeklyCheckInsTasks,
  lastWeeklyCheckInDate,
} from '/redux/selector/client.selector';
import {allReportData} from '/redux/selector/report.selector';
import {withProps} from '/util/selector.util';

import {WeeklyCheckIns} from './WeeklyCheckIns';

export default connect(
  createStructuredSelector({
    hasWeeklyCheckInsTasks,
    weeklyCheckInsTasks: withProps({type: WEEKLY_CHECK_INS})(
      clientJourneyTasksByType,
    ),
    weeklyCheckInsInitialTasks: withProps({filter: THIRD_TAB})(
      filteredClientJourneyTasks,
    ),
    reportData: allReportData,
    currentCheckInDate: currentWeeklyCheckInDate,
    lastCheckInDate: lastWeeklyCheckInDate,
  }),
  dispatch => ({
    fetchClientJourneyTask: ({clientId, type, task, reportData}: any) =>
      // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
      dispatch(fetchClientJourneyTask({clientId, type, task, reportData})),
    setClientJourneyTasks: ({clientId, type, tasks}: any) =>
      // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
      dispatch(setClientJourneyTasks({clientId, type, tasks})),
    setClientJourneyState: ({clientId, type, stateName, stateValue}: any) =>
      dispatch(
        // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
        setClientJourneyState({
          clientId,
          type,
          stateName,
          stateValue,
        }),
      ),
  }),
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    fetchClientJourneyTask: ({task}: any) => {
      const {clientId} = ownProps;
      const {reportData} = stateProps;

      return dispatchProps.fetchClientJourneyTask({
        type: WEEKLY_CHECK_INS,
        clientId,
        task,
        reportData,
      });
    },
    setClientJourneyTasks: ({tasks}: any) => {
      const {clientId} = ownProps;
      return dispatchProps.setClientJourneyTasks({
        type: WEEKLY_CHECK_INS,
        clientId,
        tasks,
      });
    },
    setClientJourneyState: () => {
      const {clientId} = ownProps;
      return dispatchProps.setClientJourneyState({
        clientId,
        type: WEEKLY_CHECK_INS,
        stateName: CLIENT_JOURNEY_STATE_IS_LOADING,
        stateValue: true,
      });
    },
  }),
)(WeeklyCheckIns);
